import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sainsburys-tech/bolt';
import * as Styled from './PageNotFound.styles';

var PageNotFound = function PageNotFound(_ref) {
  var heading = _ref.heading,
      subHeading = _ref.subHeading,
      links = _ref.links,
      dataTest = _ref['data-test'];
  return /*#__PURE__*/React.createElement(Styled.Container, {
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement("h1", null, heading), /*#__PURE__*/React.createElement("p", null, subHeading), /*#__PURE__*/React.createElement(Styled.ButtonsContainer, null, links.map(function (link, index) {
    return /*#__PURE__*/React.createElement("a", {
      key: "".concat(link.href, "-").concat(link.text),
      title: link.title,
      className: "page-not-found-button-link",
      onClick: function onClick(evt) {
        return typeof link.handler === 'function' ? link.handler(evt, link.href) : false;
      },
      href: link.href
    }, /*#__PURE__*/React.createElement(Button, {
      "data-test": "".concat(dataTest, "-component=button-").concat(index),
      kind: "secondary",
      full: true
    }, link.text));
  })));
};

PageNotFound.propTypes = {
  /**
   * Custom heading
   */
  heading: PropTypes.string,

  /**
   * Custom subheading
   */
  subHeading: PropTypes.string,

  /**
   * Send in your own array of objects for all needed links
   */
  links: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    title: PropTypes.string,
    handler: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
  }))
};
PageNotFound.defaultProps = {
  heading: "Oops, that didn't go to plan",
  subHeading: "We can't seem to find that page right now...",
  links: [{
    text: 'Take me home',
    href: '/',
    title: 'Take me home: Argos Homepage',
    handler: {}
  }, {
    text: 'Contact us',
    href: '/help',
    title: 'Contact us: Argos help pages',
    handler: {}
  }],
  'data-test': 'component-page-not-found'
};
export default PageNotFound;